import script from "./DistributorOrderDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributorOrderDrawer.vue?vue&type=script&setup=true&lang=js"

import "./DistributorOrderDrawer.vue?vue&type=style&index=0&id=49b2c998&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49b2c998"]])

export default __exports__